import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 text-center px-4">
      <div className="mb-8">
        <h1 className="font-heading text-8xl md:text-[10rem] font-black text-background-200 select-none">
          404
        </h1>
      </div>
      <div className="relative z-10 max-w-md">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          Page Not Found
        </h2>
        <p className="text-foreground-600 text-base leading-relaxed mb-8">
          The page you are looking for does not exist. It might have been moved, deleted, or you may have typed the URL incorrectly.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
          Back to Homepage
        </Link>
      </div>
    </div>
  );
}